"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FeaturedListingTypeKeys = void 0;
var FeaturedListingTypeKeys = exports.FeaturedListingTypeKeys = ['PROPERTY_OF_THE_WEEK', 'FEATURED_PROPERTY', 'TOP_SPOT'];
var FeaturedListingTypeValues = {
  PROPERTY_OF_THE_WEEK: {
    name: 'PROPERTY_OF_THE_WEEK',
    description: 'Property of the Week'
  },
  FEATURED_PROPERTY: {
    name: 'FEATURED_PROPERTY',
    description: 'Featured Property'
  },
  TOP_SPOT: {
    name: 'TOP_SPOT',
    description: 'Top Spot'
  }
};
var FeaturedListingType = FeaturedListingTypeValues;
var _default = exports.default = FeaturedListingType;